import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modeInput", "customAmountContainer", "customAmountInput", "currencySelect", "maxAmountLabel", "submitButton"]

  connect() {
    this.updateMaximum()
    this.toggle()
  }

  toggle() {
    if (!this.hasCustomAmountContainerTarget || !this.hasModeInputTarget) {
      return
    }

    const selectedMode = this.modeInputTargets.find((input) => input.checked)?.value
    const hasSelectedCurrency = this.hasCurrencySelectTarget && this.currencySelectTarget.value !== ""
    const showCustomAmount = selectedMode === "custom" && hasSelectedCurrency

    this.customAmountContainerTarget.classList.toggle("hidden", !showCustomAmount)

    if (!showCustomAmount && this.hasCustomAmountInputTarget) {
      this.customAmountInputTarget.value = ""
    }

    this.updateMaximum()
  }

  updateMaximum() {
    if (!this.hasCurrencySelectTarget || !this.hasMaxAmountLabelTarget || !this.hasCustomAmountInputTarget) {
      return
    }

    const option = this.currencySelectTarget.selectedOptions[0]
    const currencyCode = option?.dataset?.currencyCode
    const maxAmount = option?.dataset?.maxAmount
    const hasSelectedCurrency = this.currencySelectTarget.value !== ""

    this.modeInputTargets.forEach((input) => {
      input.disabled = !hasSelectedCurrency
    })

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !hasSelectedCurrency
    }

    if (!currencyCode || !maxAmount) {
      this.maxAmountLabelTarget.textContent = "Maximum: choose currency"
      this.customAmountContainerTarget.classList.add("hidden")
      this.customAmountInputTarget.value = ""
      this.customAmountInputTarget.disabled = true
      this.customAmountInputTarget.removeAttribute("max")
      return
    }

    this.customAmountInputTarget.disabled = false
    this.maxAmountLabelTarget.textContent = `Maximum: ${Number(maxAmount).toFixed(2)} ${currencyCode}`
    this.customAmountInputTarget.max = maxAmount
  }
}
